class RemoveGiftWrap extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items');
      cartItems.enableLoading(this.getAttribute('data-index'));

      const giftWrapping = document.querySelector('gift-wrapping');
      giftWrapping.removeGiftWrap();
    });
  }
}
customElements.define('remove-gift-wrap', RemoveGiftWrap, { extends: 'a' });

class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.giftWrapId = this.getAttribute('data-gift-wrap-id');
    this.giftWrapQuantity = parseInt(this.getAttribute('data-gift-wrap-quantity'));
    this.giftWrapping = this.getAttribute('data-gift-wrapping');
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = parseInt(this.getAttribute('items-in-cart'));
    if (!this.giftWrapQuantity) this.giftWrapQuantity = this.itemsInCart;
  }

  connectedCallback() {
    // When the gift-wrapping checkbox is checked or unchecked.
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener('change', theme.utils.debounce((event) => {
      event.target.checked ? this.setGiftWrap() : this.removeGiftWrap();
    }, 300));

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      return this.removeGiftWrap();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    if (this.giftWrapsInCart > 0 && this.giftWrapsInCart != this.giftWrapQuantity) {
      return this.setGiftWrap();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    if (this.giftWrapsInCart > 0 && this.giftWrapping.length == 0) {
      return this.setGiftWrap();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      return this.setGiftWrap();
    }
  }

  setGiftWrap() {
    this.enableLoading();

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: this.giftWrapQuantity
      },
      attributes: {
        'gift-wrapping': true
      },
      sections: sectionsToBundle
    });

    this.fetchGiftWrap(body);
  }

  removeGiftWrap() {
    this.enableLoading();

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 0
      },
      attributes: {
        'gift-wrapping': '',
        'gift-note': ''
      },
      sections: sectionsToBundle
    });

    this.fetchGiftWrap(body);
  }

  fetchGiftWrap(body) {
    fetch(`${theme.routes.cart_update_url}`, { ...theme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrapping', cart: parsedState });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  enableLoading() {
    const loader = this.querySelector('.loader');
    if (loader) loader.hidden = false;
  }
}
customElements.define('gift-wrapping', GiftWrapping);

class GiftPackaging extends HTMLElement {
  constructor() {
    super();

    this.giftPackagingId = this.getAttribute('data-gift-packaging-id');
    this.giftPackagingInCart = parseInt(this.getAttribute('data-gift-packaging-in-cart')) || 0;
  }

  connectedCallback() {
    this.checkbox = this.querySelector('[name="attributes[gift-packaging]"]');
    this.errorElement = this.querySelector('.cart-drawer__gift-error');
    if (!this.checkbox) return;

    this.checkbox.addEventListener('change', theme.utils.debounce((event) => {
      event.target.checked ? this.setGiftPackaging() : this.removeGiftPackaging();
    }, 300));

    if (this.giftPackagingId && this.checkbox.checked && this.giftPackagingInCart === 0) {
      this.setGiftPackaging();
    }
  }

  setGiftPackaging() {
    this.updateGiftPackaging(1, 'yes');
  }

  removeGiftPackaging() {
    this.updateGiftPackaging(0, '');
  }

  updateGiftPackaging(quantity, attributeValue) {
    this.enableLoading();
    this.hideError();

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    const payload = {
      attributes: {
        'gift-packaging': attributeValue
      },
      sections: sectionsToBundle
    };

    if (this.giftPackagingId) {
      payload.updates = {
        [this.giftPackagingId]: quantity
      };
    }

    const body = JSON.stringify(payload);

    fetch(`${theme.routes.cart_update_url}`, { ...theme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json().then((parsedState) => {
        if (!response.ok) throw parsedState;
        return parsedState;
      }))
      .then((parsedState) => {
        if (parsedState.errors || typeof parsedState.item_count !== 'number' || !parsedState.sections) {
          throw parsedState;
        }

        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-packaging', cart: parsedState });
      })
      .catch((error) => {
        if (this.checkbox) this.checkbox.checked = !this.checkbox.checked;
        this.showError(error);
        console.log(error);
      })
      .finally(() => {
        this.disableLoading();
      });
  }

  enableLoading() {
    const loader = this.querySelector('.loader');
    if (loader) loader.hidden = false;
  }

  disableLoading() {
    const loader = this.querySelector('.loader');
    if (loader) loader.hidden = true;
  }

  showError(error) {
    if (!this.errorElement) return;

    this.errorElement.textContent = error && error.description
      ? error.description
      : this.getAttribute('data-error-message') || '';
    this.errorElement.hidden = this.errorElement.textContent.length === 0;
  }

  hideError() {
    if (!this.errorElement) return;

    this.errorElement.textContent = '';
    this.errorElement.hidden = true;
  }
}
customElements.define('gift-packaging', GiftPackaging);

class GiftNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', theme.utils.debounce((event) => {
      const body = JSON.stringify({ attributes: { 'gift-note': event.target.value } });
      fetch(`${theme.routes.cart_update_url}`, {...theme.utils.fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('gift-note', GiftNote);
